import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ModelExampleVO } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'ag-chronocode-example-action-renderer',
  templateUrl: './ag-chronocode-example-action.renderer.html',
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Renderer des actions sur un modèle de chronocode dans le grid
 */
export class AgChronocodeExampleActionRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  modelExample: ModelExampleVO;

  refresh(params: ICellRendererParams): boolean {
    this.modelExample = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.modelExample = params.data;
    this.cdref.markForCheck();
  }
}
